import { ApplicationStore } from "src/store";

const getElectricSettings = (state: ApplicationStore) => {
    const electricSettings = state.account.settings?.electric;

    if (electricSettings === undefined) {
        throw Error("Electric settings should never be undefined.");
    }

    return electricSettings;
};

export const getIsCreditSliderEnabled = (state: ApplicationStore) => getElectricSettings(state).credit_slider_enabled;

// Is "Reserve Vehicle" enabled? Defaults true (the feature existed before the setting was added)
export const getIsReserveVehicleEnabled = (state: ApplicationStore): boolean =>
    getElectricSettings(state).reserve_vehicle_enabled ?? true;

// Is "Test Drive" enabled? Defaults false (this was rolled out gradually after adding)
export const getTestDriveEnabled = (state: ApplicationStore) => getElectricSettings(state).test_drive_enabled ?? false;
